import { getIncomeListFetch } from "../../api/api";

const state = {
  incomList: [],
  isRmbMap: {}
}

const actions = {
  async getIncomeList({ commit }, { param, cb }) {
    try {
      const data = await getIncomeListFetch({ data: JSON.stringify(param) })
      commit("setIncomeList", data)
      cb();
    } catch (e) {
      throw new Error(e)
    }
  }
}

const mutations = {
  setIncomeList(state, data) {
    state.incomList = data.incomMaps || [];
    state.isRmbMap = data.isRmbMap
  }
}

export default {
  state,
  actions,
  mutations
}